module.exports = __webpack_public_path__ + "54112eaaf79d4bfc50380e7ac1f21ff0.svg";